<app-bread-crumbs [breadcrumbs]="breadCrumbsItems"></app-bread-crumbs>
<div class="auction-grid-section mb-110" style="margin-top: 50px">
  <div class="container">
    <div class="auction-grid-title-section mb-40">
      <app-pagination-results
        [paginationData]="paginationData"
      ></app-pagination-results>
      <div class="filter-selector">
        <search-input
          [inputPlaceholder]="'auctions_list.auction_search_auction_name' | translate"
          (searchChanged)="handleSearch($event)"
          [(search)]="searchVal"
          (searchEmpty)="resetSearch()"
          [isLoading]="isLoading"
          data-translation-key="auction_search_auction_name"
        ></search-input>
        <div class="filter filter-container__sorting pb-0">
          <select
            class="sorting-select"
            aria-label="Sorting Select"
            aria-describedby="Language Select"
            [value]="filterBy"
            (change)="handleFilter($event)"
            [disabled]="isLoading"
          >
            <option selected disabled data-translation-key="auction_filter_by">
              {{ 'auction.filter_by' | translate }}
            </option>
            <option value="all" data-translation-key="auction_all">
              {{ 'auction.all' | translate }}
            </option>

            <option
              value="upcoming"
              data-translation-key="auction_upcoming_auctions"
            >
              <span>{{ 'auction.upcoming_auctions' | translate }}</span>
            </option>

            <option
              value="active"
              data-translation-key="auction_active_auctions"
            >
              <span>{{ 'auction.active_auctions' | translate }}</span>
            </option>
            <option
              value="previous"
              data-translation-key="auction_previous_auctions"
            >
              <span>{{ 'auction.previous_auctions' | translate }}</span>
            </option>
          </select>
        </div>
        <div class="grid-view">
          <button
            class=""
            (click)="toggleLayout()"
            [ngClass]="{ active: !isGridLayout }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <g>
                <rect x="0" y="0" width="20" height="3.64741" rx="1.8237" />
                <rect x="0" y="8" width="20" height="3.64741" rx="1.8237" />
                <rect x="0" y="16" width="20" height="3.64741" rx="1.8237" />
              </g>
            </svg>
          </button>

          <button
            class=""
            [ngClass]="{ active: isGridLayout }"
            (click)="toggleLayout()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
            >
              <g clip-path="url(#clip0_1610_1442)">
                <rect width="5.10638" height="5.10638" rx="2.55319" />
                <rect
                  y="7.44678"
                  width="5.10638"
                  height="5.10638"
                  rx="2.55319"
                />
                <rect
                  y="14.8937"
                  width="5.10638"
                  height="5.10638"
                  rx="2.55319"
                />
                <rect
                  x="7.44678"
                  width="5.10638"
                  height="5.10638"
                  rx="2.55319"
                />
                <rect
                  x="7.44678"
                  y="7.44678"
                  width="5.10638"
                  height="5.10638"
                  rx="2.55319"
                />
                <rect
                  x="7.44678"
                  y="14.8937"
                  width="5.10638"
                  height="5.10638"
                  rx="2.55319"
                />
                <rect
                  x="14.8936"
                  width="5.10638"
                  height="5.10638"
                  rx="2.55319"
                />
                <rect
                  x="14.8936"
                  y="7.44678"
                  width="5.10638"
                  height="5.10638"
                  rx="2.55319"
                />
                <rect
                  x="14.8936"
                  y="14.8937"
                  width="5.10638"
                  height="5.10638"
                  rx="2.55319"
                />
              </g>
            </svg>
          </button>
        </div>
      </div>
    </div>
    <ng-container *ngIf="!isLoading">
      <div class="list-grid-product-wrap">
        <div class="row g-4 mb-60" *ngIf="isGridLayout">
          <ng-container *ngIf="isGridLoaded">
            <ng-container *ngFor="let item of auctions; let i = index; trackBy: trackByAuctionId">
              <div
                class="col-xl-3 col-md-4 col-sm-6 col-12 item wow animate fadeInDown"
                attr.data-wow-delay="{{ i + 200 }}ms"
                data-wow-duration="1500ms"
                (click)="cardClicked($event, item)"
              >
                <app-buyer-auction-card
                  [darkTimer]="item.auc_type == 'upcoming'"
                  [showType]="true"
                  [loggedIn]="loggedIn"
                  [statusReady]="dynamicSettingsLoaded"
                  [auction]="item"
                  [auctionType]="item.auc_type"
                  (actionFired)="handleActions($event)"
                  [showFavoriteButton]="false"
                  class="auction-card-sm"
                >
                </app-buyer-auction-card>
              </div>
            </ng-container>
          </ng-container>
          <div *ngIf="!isGridLoaded" class="row g-4 mb-60">
            <app-skeleton-loader
              class="col-xl-3 col-lg-4 col-md-6"
              type="auction-card"
              *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
            ></app-skeleton-loader>
          </div>
        </div>
        <div class="row g-4 mb-60" *ngIf="!isGridLayout">
          <div
            class="col-lg-12 col-md-12 col-sm-12 col-12"
            *ngIf="isTableLoaded"
          >
            <app-base-table
              class="mt-5 catalogue-table"
              [tableColumns]="tableColumns"
              [tableData]="auctions"
              [isLoading]="isLoading"
              (onTableRowClicked)="rowClicked($event)"
              [rowClassFn]="getRowClass"
              [tableStyle]="'buyer'"
            >
            </app-base-table>
          </div>
          <div *ngIf="!isTableLoaded">
            <app-skeleton-loader type="table"></app-skeleton-loader>
          </div>
        </div>
      </div>

      <div *ngIf="!isLoading && auctions?.length == 0">
        <app-no-data
          [showImg]="false"
          [message]="{
            message: 'auction.no_data_available' | translate,
            translationsKey: 'auction_no_data_available'
          }"
          [subMessage]="{ subMessage: '', translationsKey: '' }"
        >
        </app-no-data>
      </div>
      <app-pagination
        [currentPage]="page || 1"
        [totalPages]="paginationData?.totalPages"
        (pageChanged)="onPageChanged($event)"
      >
      </app-pagination>
    </ng-container>
    <ng-container *ngIf="isLoading">
      <div class="row g-4 mb-60">
        <app-skeleton-loader
          class="col-xl-3 col-lg-4 col-md-6"
          type="auction-card"
          *ngFor="let item of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
        ></app-skeleton-loader>
      </div>
    </ng-container>
  </div>
</div>

<!-- <ng-template #copyTemplate let-element="element">
  <button
    class="btn btn-transparent cpy"
    [cdkCopyToClipboard]="
      frontUrl +
      '/buyer/auctions/' +
      element?.slug +
      '?auctionTypePage=' +
      element?.auc_type
    "
    (click)="cpy($event)"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M11.6875 5.84375V4.25C11.6875 3.82731 11.5196 3.42193 11.2207 3.12305C10.9218 2.82416 10.5164 2.65625 10.0937 2.65625H4.25C3.82731 2.65625 3.42193 2.82416 3.12305 3.12305C2.82416 3.42193 2.65625 3.82731 2.65625 4.25V10.0937C2.65625 10.5164 2.82416 10.9218 3.12305 11.2207C3.42193 11.5196 3.82731 11.6875 4.25 11.6875H5.84375M11.6875 5.84375H12.75C13.1727 5.84375 13.5781 6.01166 13.877 6.31055C14.1758 6.60943 14.3437 7.01481 14.3437 7.4375V12.75C14.3437 13.1727 14.1758 13.5781 13.877 13.877C13.5781 14.1758 13.1727 14.3437 12.75 14.3437H7.4375C7.01481 14.3437 6.60943 14.1758 6.31055 13.877C6.01166 13.5781 5.84375 13.1727 5.84375 12.75V11.6875M11.6875 5.84375H7.4375C7.01481 5.84375 6.60943 6.01166 6.31055 6.31055C6.01166 6.60943 5.84375 7.01481 5.84375 7.4375V11.6875"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</ng-template> -->
<ng-template #termsTemplate let-element="element">
  <a
    *ngIf="element?.seller_terms != null"
    (click)="goToTermsAndConditions($event, element)"
    class="ms-3 cursor-pointer terms-link"
    data-translation-key="auction_terms_and_condition"
    >{{ 'auction.terms_and_condition' | translate }}</a
  >
</ng-template>
<ng-template #auctionNameTemplate let-element="element">
  <span class="img-container bold-text horse-name">
    <button
      class="btn btn-transparent cpy"
      [cdkCopyToClipboard]="
        frontUrl +
        '/buyer/auctions/' +
        element?.slug +
        '?auctionTypePage=' +
        element?.auc_type
      "
      (click)="cpy($event)"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
      >
        <path
          d="M11.6875 5.84375V4.25C11.6875 3.82731 11.5196 3.42193 11.2207 3.12305C10.9218 2.82416 10.5164 2.65625 10.0937 2.65625H4.25C3.82731 2.65625 3.42193 2.82416 3.12305 3.12305C2.82416 3.42193 2.65625 3.82731 2.65625 4.25V10.0937C2.65625 10.5164 2.82416 10.9218 3.12305 11.2207C3.42193 11.5196 3.82731 11.6875 4.25 11.6875H5.84375M11.6875 5.84375H12.75C13.1727 5.84375 13.5781 6.01166 13.877 6.31055C14.1758 6.60943 14.3437 7.01481 14.3437 7.4375V12.75C14.3437 13.1727 14.1758 13.5781 13.877 13.877C13.5781 14.1758 13.1727 14.3437 12.75 14.3437H7.4375C7.01481 14.3437 6.60943 14.1758 6.31055 13.877C6.01166 13.5781 5.84375 13.1727 5.84375 12.75V11.6875M11.6875 5.84375H7.4375C7.01481 5.84375 6.60943 6.01166 6.31055 6.31055C6.01166 6.60943 5.84375 7.01481 5.84375 7.4375V11.6875"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    <img [src]="element?.image?.url || '/assets/images/defualt-image.jpg'" />
    {{ element?.name | localizedName }}
  </span>
</ng-template>
<ng-template #auctionTypeTemplate let-element="element">
  <button disabled mat-stroked-button class="{{ element?.auc_type }}">
    <span *ngIf="element?.auc_type === 'active'">{{ 'auction.active_auction' | translate }}</span>
    <span *ngIf="element?.auc_type === 'previous'">{{ 'auction.previous_auction' | translate }}</span>
    <span *ngIf="element?.auc_type === 'upcoming'">{{ 'auction.upcoming_auction' | translate }}</span>
  </button>
</ng-template>
<ng-template #sellerNameTemplate let-element="element">
  <span class="img-container bold-text horse-name">
    <img
      [src]="
        element?.seller?.user?.profile_picture ||
        '/assets/images/defualt-image.jpg'
      "
    />
    {{ element?.seller?.user?.name }}
  </span>
</ng-template>
<ng-template #actionsTemplate let-element="element">
  <div class="d-flex align-items-center">
    <!-- BXS-3589: defer status-dependent buttons until the buyer's application status is resolved -->
    @if (!loggedIn || dynamicSettingsLoaded) {
    <!-- Blocked/Suspended Status Button for Table View -->
    <ng-container *ngIf="isBlockedOrSuspended(element) && loggedIn && element?.auc_type == 'active'">
      <button class="btn bid-btn blocked-suspended-btn" [class.blocked]="isBlocked(element)" [class.suspended]="isSuspended(element)" disabled>
        <ng-container *ngIf="isBlocked(element)">
          <mat-icon class="status-icon">block</mat-icon>
          {{ 'buyer_status.blocked' | translate }}
        </ng-container>
        <ng-container *ngIf="isSuspended(element) && !isBlocked(element)">
          <mat-icon class="status-icon">pause_circle</mat-icon>
          {{ 'buyer_status.suspended' | translate }}
        </ng-container>
      </button>
    </ng-container>

    <ng-container *ngIf="element?.auc_type != 'previous' && !isBlockedOrSuspended(element)">
      <app-request-to-bid-button
        *ngIf="
          !loggedIn ||
          (!element?.request_to_join_status &&
            element?.auction_buyer_last_record == null &&
            !element?.invited_buyer &&
            !element?.accepted_invited_buyer)
        "
        [loggedIn]="loggedIn"
        [auctionSettings]="element"
        [horseDetails]="{
          auc_id: element?.id,
          buyer_document_categories: element?.buyer_document_categories
        }"
        [theme]="'request'"
        [aucType]="element?.auc_type"
        [terms]="{
          buyer_accepted: element?.buyer_accepted_seller_terms,
          seller_terms: element?.seller_terms
        }"
        (fetchData)="handleActions('load_data', element)"
      ></app-request-to-bid-button>

      <button
        class="btn bid-btn"
        *ngIf="
          loggedIn &&
          element?.auc_type == 'active' &&
          element?.auction_buyer_last_record
        "
        (click)="handleActions({ action: 'place', data: element })"
        data-translation-key="auction_place_bid"
      >
        {{ 'auction.place_bid' | translate }}
      </button>

      <ng-container
        *ngIf="
          loggedIn &&
          element?.request_to_join &&
          element?.request_to_join_status == false &&
          element?.auc_type !== 'previous'
        "
      >
        <button class="rejected" data-translation-key="auction_rejected">
          <span>
            {{ 'auction.rejected' | translate }}
          </span>
        </button>
      </ng-container>
    </ng-container>
    <button
      class="btn bid-btn"
      *ngIf="
        element?.auc_type == 'my-auctions' ||
        (element?.auc_type == 'upcoming' &&
          loggedIn &&
          !(
            !element?.request_to_join_status &&
            element?.auction_buyer_last_record === null &&
            !element?.invited_buyer &&
            !element?.accepted_invited_buyer
          )) ||
        element?.auc_type == 'previous'
      "
      (click)="handleActions($event, 'place')"
      data-translation-key="auction_view_catalogue"
    >
      {{ 'auction.view_catalogue' | translate }}
    </button>
    } @else {
    <mat-spinner [diameter]="20"></mat-spinner>
    }
  </div>
</ng-template>
